export const PACKAGE_GROUP = "package_group";
export const segmentationOptions = [
  { label: "Brand", value: "brand", id: 1 },
  { label: "Category", value: "category", id: 2 },
  { label: "Category_Growth", value: "category_growth", id: 3 },
  { label: "Family", value: "family", id: 4 },
  { label: "Inner_Pack", value: "inner_pack", id: 5 },
  { label: "IRI_Segment", value: "iri_segment", id: 6 },
  { label: "IRI_Segment_With_Singles", value: "iri_segment_with_singles", id: 7 },
  { label: "IRI_Type", value: "iri_type", id: 8 },
  { label: "IRI_Type_With_Singles", value: "iri_type_with_singles", id: 9 },
  { label: "Manufacturer", value: "manufacturer", id: 10 },
  { label: "Package", value: "package", id: 11 },
  { label: "Package_group", value: PACKAGE_GROUP, id: 12 },
  { label: "Product_Name", value: "product_nm", id: 13 },
  { label: "Subcategory", value: "subcategory", id: 14 },
  { label: "WAMP", value: "wamp", id: 15 },
];

const columnCubicShare = {
  header: "Cubic Share",
  field: "cubic_share_post",
  formatter: (value: number) => `${value}%`,
  searchable: false,
};
const columnCubicSharePrior = {
  header: "Cubic Share Prior",
  field: "cubic_share_prior",
  formatter: (value: number) => `${value}%`,

  searchable: false,
};
const columnShareChange = {
  header: "Share Change",
  field: "share_change",
  formatter: (value: number) => `${(value || 0).toFixed(2)}%`,

  searchable: false,
};
const columnAdds = { header: "Adds", field: "adds", searchable: false };
const columnDeletes = { header: "Deletes", field: "deletes", searchable: false };
const columnMaintains = { header: "Maintains", field: "maintains", searchable: false };
const columnTotalPODs = { header: "Total PODs", field: "total_pods_post", searchable: false };
const columnTotalPODsPrior = {
  header: "Total PODs Prior",
  field: "total_pods_prior",

  searchable: false,
};
const columnPODChange = { header: "POD change", field: "pod_change", searchable: false };
const columnAddsPerStore = {
  header: "Adds per Store",
  field: "adds_per_store",
  formatter: (value: number) => (value || 0).toFixed(2),

  searchable: false,
};
const columnDeletesPerStore = {
  header: "Deletes per Store",
  field: "deletes_per_store",
  formatter: (value: number) => (value || 0).toFixed(2),

  searchable: false,
};
const columnCubicSpacePost = {
  header: "Cubic space post",
  field: "cubic_space_post",
  formatter: (value: number) => (value || 0).toFixed(2),

  searchable: false,
};
const columnCubicSpacePrior = {
  header: "Cubic space prior",
  field: "total_cubic_prior",
  formatter: (value: number) => (value || 0).toFixed(2),

  searchable: false,
};
const columnCubicSpaceChange = {
  header: "Cubic space change",
  field: "cubic_space_change",
  formatter: (value: number) => (value || 0).toFixed(2),

  searchable: false,
};

export const segmentationTableColumnsAll = [
  columnCubicShare,
  columnCubicSharePrior,
  columnShareChange,
  columnAdds,
  columnDeletes,
  columnMaintains,
  columnTotalPODs,
  columnTotalPODsPrior,
  columnPODChange,
  columnAddsPerStore,
  columnDeletesPerStore,
  columnCubicSpacePost,
  columnCubicSpacePrior,
  columnCubicSpaceChange,
];
export const segmentationTableColumnsSimplified = [
  columnCubicShare,
  columnTotalPODs,
  columnCubicSpacePost,
];
